export class ListOptionModel {
    constructor(
         public listLabel: string,
         public listValue: any
    ) {}
}
